const VipTransactionHistoryExports = {
  VIP_AWARD_POINTS: "vip-award-points",
  VIP_PAY_WITH_POINTS: "vip-pay-with-points",
  VIP_REDEEM_POINTS: "vip-redeem-points",
  VIP_MANUAL_AT_ADMIN: "manual-at-admin",
};

export default VipTransactionHistoryExports;
